//special memoized wrapper for our table body that we will use during column resizing
import React from "react";
import { TableBody } from "./table-body";

export const MemoizedTableBody = React.memo(
  TableBody,
  (prev, next) => prev.table.options.data === next.table.options.data,
) as typeof TableBody;
